var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.03 16.09a8.25 8.25 0 1 1 1.06-1.06l6.19 6.19a.75.75 0 1 1-1.06 1.06zm1.47-6.34a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;